import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { EnergyTypes } from '@app/shared/models/energy-types';

@Injectable({
  providedIn: 'root',
})
export class EnergyTypesService extends ApiService {
  private cache$?: Observable<EnergyTypes[]>;

  constructor(public http: HttpClient) {
    super(http);
  }

  public getAllActive(): Observable<EnergyTypes[]> {
    if (!this.cache$) {
      this.cache$ = this.requestEnergyTypes().pipe(shareReplay(1));
    }
    return this.cache$;
  }

  private requestEnergyTypes(): Observable<EnergyTypes[]> {
    const uri = `socrates/meters/api/references/EnergyTypes?$filter=isActive&$orderBy=sortOrder`;
    return this.http.get<EnergyTypes[]>(this.endpoint(uri));
  }
}
